export const updateMaintenanceService = (fetch) => async (maintenance) => {
  try {
    const response = await fetch({
      url: `/api/v1/mantenimiento/${maintenance.id}`,
      method: "put",
      body: maintenance,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
